import { type FC, type ReactNode } from "react";

import { css, cx } from "@emotion/css";
import { Colors, type FormFieldProps } from "@snapchat/snap-design-system";

import { inputStyles } from "../styles";

import { LabelWithTooltip } from "./LabelWithTooltip";
import { LabelControl } from "./ReadOnlyInput.styles";

type ReadOnlyInputProps<T, TDisplay> = FormFieldProps<T> & {
    valueDisplay?: TDisplay;
    tooltip?: ReactNode;
};

const readOnlyInputStyles = css`
    background: ${Colors.Gray.V50}
        repeating-linear-gradient(
            45deg,
            ${Colors.Gray.V100},
            ${Colors.Gray.V100} 1px,
            ${Colors.Gray.V50} 0,
            ${Colors.Gray.V50} 5px
        );
`;

// TODO extract input props like required and type if needed
// TOOD - check if we need status here
export const ReadOnlyInput: FC<ReadOnlyInputProps<string, string>> = ({
    value,
    valueDisplay,
    label,
    name,
    id,
    tooltip,
}) => {
    const valueInputId = id ?? name;
    const valDisplay = valueDisplay ?? value;

    return (
        <LabelControl htmlFor={valueInputId}>
            <LabelWithTooltip label={label} content={tooltip} />
            <input required={true} id={valueInputId} type="hidden" name={name} value={value} />
            <input type="text" className={cx(inputStyles, readOnlyInputStyles)} value={valDisplay} disabled />
        </LabelControl>
    );
};
